// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { Loader } from '@tls/treact-ui';
import React from 'react';
import styled from 'styled-components';

// treact-ui's Loader drops unknown props, so the testid needs an element of its own.
export default function TestableLoader({ label, inverted, 'data-testid': testId }: Readonly<Props>) {
  return (
    <Contents data-testid={testId}>
      <Loader label={label} inverted={inverted} />
    </Contents>
  );
}

// Shrink-wraps the loader, so it stays the same flex item as before.
// Deliberately not display:contents — that has no bounding box and Playwright would report it as hidden.
const Contents = styled.span`
  display: inline-flex;
`;

export type Props = {
  label: string;
  inverted?: boolean;
  'data-testid': string;
};
